(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["how-were-different"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-diff-anim]');
    if (!roots.length) return;
    roots.forEach(init);

    function init(root) {
      var canvas = root.querySelector('[data-diff-canvas]');
      var dataEl = root.querySelector('[data-diff-frames]');
      if (!canvas || !dataEl) return;

      var urls;
      try {
        urls = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!urls || !urls.length) return;

      var ctx = canvas.getContext('2d');
      var images = new Array(urls.length);
      var lastDrawn = -1;
      var targetFrame = 0;
      var displayedFrame = -1;
      var smoothing = 0.18;
      var rafRunning = false;
      var section = root.closest('[data-diff]') || root.parentElement;
      var tableEl = section.querySelector('.diff__cmp');
      var pinEl = root.querySelector('.diff__media-pin');
      var mqlDesktop = window.matchMedia('(min-width: 1025px)');
      var startScroll = 0;
      var endScroll = 0;
      var started = false;

      function preload() {
        if (started) return;
        started = true;
        urls.forEach(function (url, i) {
          var img = new Image();
          img.decoding = 'async';
          img.onload = function () {
            images[i] = img;
            if (i === 0 && lastDrawn === -1) draw();
            if (i === Math.round(displayedFrame)) draw();
          };
          img.src = url;
        });
      }

      function nearestLoaded(i) {
        if (images[i]) return i;
        for (var d = 1; d < urls.length; d++) {
          if (i - d >= 0 && images[i - d]) return i - d;
          if (i + d < urls.length && images[i + d]) return i + d;
        }
        return -1;
      }

      function draw() {
        var i = Math.min(urls.length - 1, Math.max(0, Math.round(displayedFrame)));
        var target = nearestLoaded(i);
        if (target < 0 || target === lastDrawn) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(images[target], 0, 0, canvas.width, canvas.height);
        lastDrawn = target;
      }

      function tick() {
        if (displayedFrame < 0) {
          displayedFrame = targetFrame;
        } else {
          displayedFrame += (targetFrame - displayedFrame) * smoothing;
        }
        draw();
        if (Math.abs(targetFrame - displayedFrame) > 0.1) {
          requestAnimationFrame(tick);
        } else {
          displayedFrame = targetFrame;
          draw();
          rafRunning = false;
        }
      }

      function startTick() {
        if (rafRunning) return;
        rafRunning = true;
        requestAnimationFrame(tick);
      }

      function absY(el) {
        return el.getBoundingClientRect().top + (window.pageYOffset || window.scrollY || 0);
      }

      function computeRange() {
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (mqlDesktop.matches) {
          var pinH = pinEl ? pinEl.offsetHeight : 0;
          var stickyTop = pinEl ? parseFloat(getComputedStyle(pinEl).top) || 0 : 0;
          startScroll = absY(root) + pinH * 0.95 - vh;
          var chartBottom = absY(tableEl || section) + (tableEl ? tableEl.offsetHeight : 0);
          endScroll = chartBottom - stickyTop - pinH;
        } else {
          startScroll = absY(tableEl || section) + (tableEl ? tableEl.offsetHeight : 0) - vh;
          endScroll = absY(root) + root.offsetHeight;
        }
        if (endScroll - startScroll < 150) {
          endScroll = startScroll + 150;
        }
      }

      function updateProgress() {
        var scrollY = window.pageYOffset || window.scrollY || 0;
        var range = endScroll - startScroll;
        var p = range > 0 ? (scrollY - startScroll) / range : 0;
        if (p < 0) p = 0;
        else if (p > 1) p = 1;
        var eased = p;
        targetFrame = eased * (urls.length - 1);
        startTick();
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                preload();
                io.disconnect();
              }
            });
          },
          { rootMargin: '200% 0px 200% 0px' }
        );
        io.observe(section);
      } else {
        preload();
      }

      function recompute() {
        computeRange();
        updateProgress();
      }

      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', recompute);
      if (mqlDesktop.addEventListener) {
        mqlDesktop.addEventListener('change', recompute);
      } else if (mqlDesktop.addListener) {
        mqlDesktop.addListener(recompute);
      }
      window.addEventListener('load', recompute);

      computeRange();
      updateProgress();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-hero]').forEach(function (root) {
      var cta = root.querySelector('[data-cta]');
      var ctaLabel = root.querySelector('[data-cta-label]');
      var ctaErr = root.querySelector('[data-cta-error]');
      var tiersWrap = root.querySelector('[data-tiers]');
      var gifts = root.querySelectorAll('[data-gift]');
      var defaultLabel = 'ADD TO CART';

      // Keep "Ships by …" auto-updated to tomorrow, even when the page is served from cache.
      var shipsDateEl = root.querySelector('[data-ships-date]');
      if (shipsDateEl) {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        shipsDateEl.textContent = tomorrow.toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        });
      }

      function mode() {
        return root.dataset.buyMode || 'once';
      }
      function selected() {
        return root.querySelector('[data-tiers] input:checked');
      }

      var toggle = root.querySelector('[data-toggle]');
      if (toggle) {
        toggle.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-mode]');
          if (!btn) return;
          toggle.querySelectorAll('button').forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          root.dataset.buyMode = btn.dataset.mode;
          syncCta();
          syncGifts();
        });
      }

      var onceCta = root.querySelector('[data-once-cta]');
      if (onceCta && toggle) {
        onceCta.addEventListener('click', function () {
          if (document.documentElement.classList.contains('marketing-mode')) {
            document.documentElement.classList.remove('marketing-mode');
          }
          var onceBtn = toggle.querySelector('button[data-mode="once"]');
          if (onceBtn) onceBtn.click();
          if (toggle.scrollIntoView) {
            toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        onceCta.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onceCta.click();
          }
        });
      }

      var thumbs = root.querySelector('[data-thumbs]');
      var mainImg = root.querySelector('[data-main] img');
      var mainImgWrap = root.querySelector('[data-main]');
      var galleryAnimating = false;
      var GALLERY_DURATION = 600;
      var GALLERY_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

      var galleryPreloadCache = Object.create(null);
      function preloadGalleryImage(src) {
        if (!src) return Promise.resolve();
        if (galleryPreloadCache[src]) return galleryPreloadCache[src];
        galleryPreloadCache[src] = new Promise(function (resolve) {
          var img = new Image();
          img.onload = img.onerror = function () {
            resolve();
          };
          img.src = src;
        });
        return galleryPreloadCache[src];
      }

      function slideTransition(newSrc, direction) {
        if (!mainImg || !mainImgWrap) return;
        if (galleryAnimating) return;
        galleryAnimating = true;

        preloadGalleryImage(newSrc).then(function () {
          var oldImg = mainImg.cloneNode(true);
          oldImg.removeAttribute('data-main');
          oldImg.style.zIndex = '2';
          mainImgWrap.insertBefore(oldImg, mainImg.nextSibling);

          var outTo = direction === 'prev' ? '100%' : '-100%';
          var inFrom = direction === 'prev' ? '-100%' : '100%';

          mainImg.src = newSrc;
          mainImg.removeAttribute('srcset');

          var outAnim = oldImg.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + outTo + ')' }], {
            duration: GALLERY_DURATION,
            easing: GALLERY_EASING,
            fill: 'forwards',
          });
          var inAnim = mainImg.animate([{ transform: 'translateX(' + inFrom + ')' }, { transform: 'translateX(0)' }], {
            duration: GALLERY_DURATION,
            easing: GALLERY_EASING,
          });

          var done = 0;
          function finish() {
            done++;
            if (done >= 2) {
              oldImg.remove();
              galleryAnimating = false;
            }
          }
          outAnim.onfinish = finish;
          outAnim.oncancel = finish;
          inAnim.onfinish = finish;
          inAnim.oncancel = finish;
        });
      }

      function preloadAllGalleryImages() {
        if (!thumbs) return;
        thumbs.querySelectorAll('button[data-full]').forEach(function (btn) {
          preloadGalleryImage(btn.getAttribute('data-full'));
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(preloadAllGalleryImages, { timeout: 2000 });
      } else {
        setTimeout(preloadAllGalleryImages, 1500);
      }

      function getActiveIndex(btns) {
        var i = btns.findIndex(function (b) {
          return b.classList.contains('is-active');
        });
        return i < 0 ? 0 : i;
      }

      function activateThumb(btn, direction) {
        if (!btn || !thumbs) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        var prevIdx = getActiveIndex(btns);
        var nextIdx = btns.indexOf(btn);
        if (nextIdx === prevIdx) return;

        btns.forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        var li = btn.parentElement;
        if (li && thumbs) {
          var thumbRect = thumbs.getBoundingClientRect();
          var liRect = li.getBoundingClientRect();
          if (liRect.left < thumbRect.left || liRect.right > thumbRect.right) {
            thumbs.scrollTo({
              left: thumbs.scrollLeft + (liRect.left - thumbRect.left) - (thumbRect.width - liRect.width) / 2,
              behavior: 'smooth',
            });
          }
        }

        if (!mainImg) return;

        var full = btn.getAttribute('data-full');
        var img = btn.querySelector('img');
        var nextSrc = full || (img && img.src);
        if (!nextSrc) return;

        // Direction: explicit if provided, otherwise infer from index delta.
        var dir = direction || (nextIdx > prevIdx ? 'next' : 'prev');
        slideTransition(nextSrc, dir);
      }

      if (thumbs) {
        thumbs.addEventListener('click', function (e) {
          var btn = e.target.closest('button[data-thumb]');
          if (btn) activateThumb(btn);
        });
      }

      function advanceGallery(direction) {
        if (!thumbs) return;
        var btns = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
        if (!btns.length) return;
        var idx = getActiveIndex(btns);
        var step = direction === 'next' ? 1 : -1;
        var target = (idx + step + btns.length) % btns.length;
        activateThumb(btns[target], direction);
      }

      root.querySelectorAll('[data-nav]').forEach(function (nav) {
        nav.addEventListener('click', function () {
          advanceGallery(nav.dataset.nav === 'next' ? 'next' : 'prev');
        });
      });

      // Touch swipe on the main image
      if (mainImgWrap) {
        var swipeStartX = null;
        var swipeStartY = null;
        mainImgWrap.addEventListener(
          'touchstart',
          function (e) {
            if (e.touches.length !== 1) return;
            swipeStartX = e.touches[0].clientX;
            swipeStartY = e.touches[0].clientY;
          },
          { passive: true }
        );
        mainImgWrap.addEventListener('touchend', function (e) {
          if (swipeStartX === null) return;
          var t = e.changedTouches[0];
          var dx = t.clientX - swipeStartX;
          var dy = t.clientY - swipeStartY;
          swipeStartX = null;
          swipeStartY = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          advanceGallery(dx < 0 ? 'next' : 'prev');
        });
      }

      function syncGifts() {
        var onceMode = root.dataset.buyMode === 'once';
        var sel = selected();
        var tierIdx = sel ? parseInt(sel.getAttribute('data-tier-index'), 10) : 0;
        gifts.forEach(function (g) {
          var unlock = g.getAttribute('data-unlock-tier');
          var active = !onceMode && (unlock === 'all' || tierIdx >= parseInt(unlock, 10));
          g.classList.toggle('product-hero__gift--locked', !active);
        });
      }

      function syncCta() {
        if (!cta) return;
        if (ctaErr) ctaErr.hidden = true;
        cta.removeAttribute('aria-disabled');
        cta.disabled = false;
        if (ctaLabel) ctaLabel.textContent = defaultLabel;
      }

      if (tiersWrap) {
        tiersWrap.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'ph-tier') {
            syncCta();
            syncGifts();
          }
        });
      }

      if (cta) {
        cta.addEventListener('click', function () {
          var sel = selected();
          var id = sel ? sel.getAttribute('data-variant-id') : null;
          if (!id) return;

          var isSubscribe = mode() === 'subscribe';
          var shopifyItemId = sel
            ? sel.getAttribute(isSubscribe ? 'data-shopify-subscription-item-id' : 'data-shopify-item-id')
            : '';
          var sellingPlanId = sel ? sel.getAttribute('data-selling-plan-id') : '';
          var item = { id: Number(id), quantity: 1 };
          if (shopifyItemId) {
            item.properties = { _shopify_item_id: shopifyItemId };
          }
          if (isSubscribe && sellingPlanId) {
            item.selling_plan = Number(sellingPlanId);
          }

          cta.dataset.busy = 'true';
          if (ctaLabel) ctaLabel.textContent = defaultLabel;
          if (ctaErr) ctaErr.hidden = true;

          var reset = function () {
            cta.dataset.busy = 'false';
            cta.disabled = false;
            syncCta();
          };

          if (window.cartDrawer && window.cartDrawer.addItem) {
            window.cartDrawer.addItem(item).then(reset, reset);
          } else {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [item] }),
            })
              .then(function (res) {
                if (!res.ok) {
                  return res.json().then(function (d) {
                    throw new Error((d && d.description) || 'Could not add to cart.');
                  });
                }
                return res.json();
              })
              .catch(function (err) {
                if (ctaErr) {
                  ctaErr.textContent = err.message;
                  ctaErr.hidden = false;
                }
              })
              .finally(reset);
          }
        });
      }

      // Init
      syncCta();
      syncGifts();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["risk-free-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-scroll-top]');
    if (!link) return;
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
